/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import provisionDocumentTeasersStyle from "./provisionDocumentTeasersStyle";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";

const ProvisionDocumentTeasers = () => {
  return (
    <Grid container direction={"column"}>
      <Grid item xs={12} component={Link} to={"/servicewelt/vorsorge/patientenverfuegung/antrag"} sx={provisionDocumentTeasersStyle.teaserCard}>
        <Grid container alignItems={"stretch"} direction={"column"} justifyContent={"center"} sx={provisionDocumentTeasersStyle.teaserImagePatientDecree}>
          <Grid item sx={provisionDocumentTeasersStyle.teaserCardTextPatientDecree}>
            Individuelle & rechtssichere Patientenverfügung
          </Grid>
          <Grid item sx={provisionDocumentTeasersStyle.buttonContainer}>
            <Button sx={provisionDocumentTeasersStyle.button} variant={"contained"}>
              Jetzt für 9,95 € erstellen
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} component={Link} to={"/servicewelt/vorsorge/vorsorgevollmacht/antrag"} sx={provisionDocumentTeasersStyle.teaserCard}>
        <Grid
          container
          alignItems={"stretch"}
          direction={"column"}
          justifyContent={"center"}
          sx={provisionDocumentTeasersStyle.teaserImageProvisionPowerOfAttorney}
        >
          <Grid item sx={provisionDocumentTeasersStyle.teaserCardTextProvisionPowerOfAttorney}>
            Individuelle & rechtssichere Vorsorgevollmacht
          </Grid>
          <Grid item sx={provisionDocumentTeasersStyle.buttonContainer}>
            <Button sx={provisionDocumentTeasersStyle.button} variant={"contained"}>
              Jetzt für 14,95 € erstellen
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProvisionDocumentTeasers;
